import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingPackagesContent } from '../../../../hooks/useVpsHostingPackagesContent';
import checkIcon from '../../../../assets/images/vpshosting/packages/Check icon.svg';
import './Packages.css';

const Packages = () => {
  const { content, isLoading } = useVpsHostingPackagesContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, intro, checkIcon: checkIconUrl, packages } = content;

  return (
    <section className="vps-hosting-packages">
      <div className="vps-hosting-packages__inner">
        <Reveal className="vps-hosting-packages__header">
          {eyebrow ? <p className="vps-hosting-packages__eyebrow">{eyebrow}</p> : null}
          <h2 className="vps-hosting-packages__title">{title}</h2>
          {intro ? <p className="vps-hosting-packages__intro">{intro}</p> : null}
        </Reveal>

        <div className="vps-hosting-packages__grid">
          {packages.map(({ price, name, description, features, cta }, index) => (
            <Reveal key={name} delay={index * 80}>
              <article className="vps-hosting-packages__card">
                <div className="vps-hosting-packages__card-top">
                  <p className="vps-hosting-packages__price">{price}</p>
                  <h3 className="vps-hosting-packages__name">{name}</h3>
                  <p className="vps-hosting-packages__description">{description}</p>
                </div>

                <ul className="vps-hosting-packages__features">
                  {features.map((feature) => (
                    <li key={feature} className="vps-hosting-packages__feature">
                      <img
                        className="vps-hosting-packages__check"
                        src={checkIconUrl || checkIcon}
                        alt=""
                        aria-hidden="true"
                      />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to={`/technology/vps-hosting/request?serverType=${encodeURIComponent(name)}`}
                  className="vps-hosting-packages__cta luxury-btn"
                >
                  {cta}
                </Link>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
